import { useEffect } from "react";
import GameMpProvider from "@/core/data-provider/data-mp/game/game-mp-provider.ts";

export default () => {
  useEffect(() => {
    const rootElement = document.getElementById("root");
    let prevInside = false;

    const handleMove = async (e: MouseEvent) => {
      if (!rootElement) {
        return;
      }

      const isInside = rootElement.contains(e.target as Node);

      if (isInside !== prevInside) {
        prevInside = isInside;

        await GameMpProvider.onMouseEnterBrowserContainer({
          isHovered: isInside,
        });
      }
    };

    document.addEventListener("mousemove", handleMove);
    return () => document.removeEventListener("mousemove", handleMove);
  }, []);
};
